import * as types from './mutation-types';

export default {
  [types.LOADING](state, payload) {
    state.loading = payload;
  },
  [types.SET_ITEMS](state, payload) {
    state.items = payload;
  },
  [types.SET_SEARCH_FILTER](state, payload) {
    state.sort.filter = payload;
  },
  [types.TOTAL](state, payload) {
    state.total = payload;
  },
};
